export default __webpack_public_path__ + "static/media/sosmed_instagram.75e0546a.png";